import type { CSSProperties } from 'react';

// Values resolved once from the centralized brand tokens (src/styles/brand.css).
const BRAND_TEAL = 'var(--tps-brand-teal)';
const BRAND_TEAL_HOVER = 'var(--tps-brand-teal-hover)';
const BRAND_TEXT_ON_TEAL = 'var(--tps-brand-text-on-teal)';

// Shared teal brand styling for buttons. IX buttons render `.btn-<variant>`, each
// reading its own `--theme-btn-<variant>--*` set inside the shadow DOM. The default
// IxButton variant is 'primary'; buttons using 'secondary'/'tertiary' read a
// DIFFERENT var set, so we override all three to guarantee the same teal regardless
// of variant.
export const brandButtonStyle: CSSProperties = {
  backgroundColor: BRAND_TEAL,
  color: BRAND_TEXT_ON_TEAL,

  '--theme-btn-primary--background': BRAND_TEAL,
  '--theme-btn-primary--background--hover': BRAND_TEAL_HOVER,
  '--theme-btn-primary--background--active': BRAND_TEAL_HOVER,
  '--theme-btn-primary--color': BRAND_TEXT_ON_TEAL,

  '--theme-btn-secondary--background': BRAND_TEAL,
  '--theme-btn-secondary--background--hover': BRAND_TEAL_HOVER,
  '--theme-btn-secondary--background--active': BRAND_TEAL_HOVER,
  '--theme-btn-secondary--border-color': BRAND_TEAL,
  '--theme-btn-secondary--border-color--hover': BRAND_TEAL_HOVER,
  '--theme-btn-secondary--border-color--active': BRAND_TEAL_HOVER,
  '--theme-btn-secondary--color': BRAND_TEXT_ON_TEAL,
  '--theme-btn-secondary--color--hover': BRAND_TEXT_ON_TEAL,
  '--theme-btn-secondary--color--active': BRAND_TEXT_ON_TEAL,

  '--theme-btn-tertiary--background': BRAND_TEAL,
  '--theme-btn-tertiary--background--hover': BRAND_TEAL_HOVER,
  '--theme-btn-tertiary--background--active': BRAND_TEAL_HOVER,
  '--theme-btn-tertiary--border-color': BRAND_TEAL,
  '--theme-btn-tertiary--border-color--hover': BRAND_TEAL_HOVER,
  '--theme-btn-tertiary--border-color--active': BRAND_TEAL_HOVER,
  '--theme-btn-tertiary--color': BRAND_TEXT_ON_TEAL,
  '--theme-btn-tertiary--color--hover': BRAND_TEXT_ON_TEAL,
  '--theme-btn-tertiary--color--active': BRAND_TEXT_ON_TEAL,
} as CSSProperties;
